import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DataType {
  id: number;
  key: number;
  productName: string;
  price: string;
  qty: number;
  imageUrl: string;
  productId: number;
  isRedemptionItem?: boolean;
  redemptionItem?: any; // RedemptionItem type
}
type CartStore = {
  productItemsSelected: DataType[];
  setProductItemsSelected: (productItem: DataType[]) => void;
};

const useCartStore = create<CartStore>()(
  persist(
    (set) => ({
      productItemsSelected: [],
      setProductItemsSelected: (newProductItemsSelected) =>
        set({ productItemsSelected: newProductItemsSelected }),
    }),
    {
      name: "cart-selected-item",
      version: 1, // Added version to force refresh of persisted data
    }
  )
);

export default useCartStore;
